import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class QueryDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'data',
      type: 'Schema.Unknown'
    },
    {
      name: 'loading',
      nullable: true,
      type: 'Schema.Boolean'
    },
    {
      name: 'retrying',
      type: 'Schema.Boolean'
    },
    {
      name: 'polling',
      type: 'Schema.Boolean'
    },
    {
      name: 'error',
      type: 'Schema.Unknown'
    },
    {
      name: 'updateAt',
      nullable: true,
      type: 'Schema.Number'
    },
    {
      name: 'props',
      type: 'Schema.Object'
    },
    {
      name: 'autoRefresh',
      type: 'Schema.Boolean'
    },
    {
      name: 'onSuccess',
      type: 'Schema.Event'
    },
    {
      name: 'onError',
      type: 'Schema.Event'
    },
    {
      name: 'transformer',
      type: 'Schema.JavaScript'
    },
    {
      name: 'timeout',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'shouldRetryOnError',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Boolean'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Boolean'
        }
      ]
    },
    {
      name: 'refreshOnWindowFocus',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Boolean'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Boolean'
        }
      ]
    },
    {
      name: 'refreshOnReconnect',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Boolean'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Boolean'
        }
      ]
    },
    {
      name: 'refreshOnHidden',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Boolean'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Boolean'
        }
      ]
    },
    {
      name: 'refreshOnOffline',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Boolean'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Boolean'
        }
      ]
    },
    {
      name: 'errorRetryCount',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'errorRetryIntervalTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'staleTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'cacheTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'loadingDebounceTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'throttleTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'debounceTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'intervalTime',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'intervalCount',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.Number'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      async: true,
      name: 'trigger',
      type: 'Schema.Function'
    },
    {
      async: true,
      name: 'abort',
      type: 'Schema.Function'
    }
  ]

  override relationTo = 'Schema.Query'
}
